import i18n from '../../../i18n'
import router from '../../../router'
import {
  ACTION_LOGIN,
  ACTION_LOGOUT,
  ACTION_REGISTER,
  ACTION_RESET_PASSWORD,
  SET_LOGGED_USER,
} from '../../types/user.types'
import { ACTION_SET_ALERT } from '../../types/alerts.types'
import { RESET_APPOINTMENT_STATE } from '../../types/appointment.types'
import { RESET_PETS_STATE } from '../../types/pets.types'
import { RESET_PROFILE_STATE } from '../../types/profile.types'
import { login, resetPassword, register } from '../../../api/user'

export default {
  [ACTION_LOGIN]: ({ commit, dispatch }, payload) => {
    login({ ...payload })
      .then((result) => {
        localStorage.setItem('token', result.data.access_token)
        localStorage.setItem('user', result.data.email)
        commit(SET_LOGGED_USER, result.data.email)
        router.push({ name: 'VisitsPage' })
      })
      .catch(() => {
        const alert = { type: 'error', message: i18n.t('alerts.loginError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_LOGOUT]: ({ commit }) => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    commit(SET_LOGGED_USER, null)
    commit(RESET_APPOINTMENT_STATE)
    commit(RESET_PETS_STATE)
    commit(RESET_PROFILE_STATE)
    router.push({ name: 'LoginPage' })
  },
  [ACTION_REGISTER]: ({ dispatch }, payload) => {
    register({ ...payload })
      .then(() => {
        const alert = { type: 'success', message: i18n.t('alerts.registerSuccess') }
        dispatch(ACTION_SET_ALERT, alert)
        setTimeout(() => router.push({ name: 'LoginPage' }), 4000)
      })
      .catch(() => {
        const alert = { type: 'error', message: i18n.t('alerts.registerError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_RESET_PASSWORD]: ({ dispatch }, payload) => {
    resetPassword({ ...payload })
      .then(() => {
        const alert = { type: 'success', message: i18n.t('alerts.resetPasswordSuccess') }
        dispatch(ACTION_SET_ALERT, alert)
        setTimeout(() => router.push({ name: 'LoginPage' }), 4000)
      })
      .catch(() => {
        const alert = { type: 'error', message: i18n.t('alerts.resetPasswordError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },

}
